export var CUSTOM_ROUTE_PLACEHOLDERS = {
    postSlug: '**postSlug**',
    postId: '**postId**',
};
